import Icon from "@/components/primitives/icon";

interface ReviewDetails {
  memberSince: string;
  rating: number;
  review: string;
  timeAgo: string;
  reviewerName?: string;
}

export default function CapperReviewCard({
  reviewDetails,
}: {
  reviewDetails: ReviewDetails;
}) {
  console.log("review details", reviewDetails);
  return (
    <div className="space-y-9 bg-dark px-9 py-9 pb-4 rounded-md">
      <div className="space-y-6">
        <h3 className="text-headline-lg text-secondary-700 uppercase">
          Member since {reviewDetails.memberSince} ago
        </h3>
        <div className="flex justify-start gap-[6px]">
          {Array.from({ length: 5 }, (_, i) => (
            <Icon
              key={i}
              name="review-star"
              size="sm"
              className={
                i < reviewDetails.rating ? "" : "opacity-30"
              }
            />
          ))}
        </div>
      </div>
      <p className="text-body-lg-medium text-secondary-700">
        {reviewDetails.review}
      </p>
      <p className="text-body-lg-regular text-secondary-500">
        {reviewDetails.timeAgo}
      </p>
    </div>
  );
}
